import React from 'react'
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Layout from "./components/App";
import HomepageLayout from './components/layout/HomepageLayout';
import About from "./components/pages/about/About";
import Contact from "./components/pages/contact/Contact";
import Confirm from "./components/pages/contact/Confirm";
import Thanks from "./components/pages/contact/Thanks";
import PaymentFailed from "./components/pages/contact/PaymentFailed";
import PaymentError from "./components/pages/contact/PaymentError";
import Error from "./components/pages/error/Error";
import FaqPage from "./components/pages/faq/FaqPage";
import OnsiteWorkshop from "./components/pages/packageDetails/OnsiteWorkshop";
import OnlineWorkshop from "./components/pages/packageDetails/OnlineWorkshop";
import Residencies from "./components/pages/packageDetails/Residencies";
import Bundles from "./components/pages/packageDetails/Bundles";
import BundleThanks from "./components/pages/contact/BundleThanks";
import Plus7 from "./components/pages/packageDetails/Plus7";
import Jobs from "./components/pages/packageDetails/Jobs";
import Funding from "./components/pages/packageDetails/Funding";
import Subscribe from "./components/pages/Home/Subscribe";
import SubscribeConfirm from "./components/pages/Home/SubscribeConfirm";
import Terms from "./components/pages/packageDetails/Terms";
import Privacy from "./components/pages/packageDetails/Privacy";
import AllWorkshops from "./components/pages/packageSidebar/AllWorkshops";
import GalleryPage from "./components/pages/gallery/GalleryPage";
import SimpleReactLightbox from "simple-react-lightbox";
import { SessionProvider } from './components/common/SessionContext';

// import all css
import "./index.css";

function Root() {
  return (
    <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Switch>

          {/*main layout*/}
          <Route exact path="/" component={HomepageLayout} />

          {/* all inner page load layout component */}

          <Layout>

            <Route
              path="/about"
              component={About}
            />
            <Route
              path="/faq"
              component={FaqPage}
            />
            <Route
              path="/gallery"
              component={GalleryPage}
            />
            <Route
              path="/contact"
              component={Contact}
            />
            <Route
              exact
              path="/confirm/:ctype/:hash"
              component={Confirm}
            />
            <Route
              exact
              path="/thanks/:ctype/:hash"
              component={Thanks}
            />
            <Route
              exact
              path="/bundle_thanks/:hash"
              component={BundleThanks}
            />
            <Route
              exact
              path="/paymentfailed/:ctype/:hash"
              component={PaymentFailed}
            />
            <Route
              exact
              path="/paymenterror/:ctype/:hash"
              component={PaymentError}
            />
            <Route
              exact
              path="/error"
              component={Error}
            />

            {/* all package pages component */}
            <Route
              path="/workshops"
              component={AllWorkshops}
            />
            <Route
              path="/onsite/:item_id"
              component={OnsiteWorkshop}
            />
            <Route
              path="/online/:item_id"
              component={OnlineWorkshop}
            />
            <Route
              path="/residencies"
              component={Residencies}
            />
            <Route
              path="/bundles"
              component={Bundles}
            />
            <Route
              path="/plus7"
              component={Plus7}
            />
            <Route
              path="/jobs"
              component={Jobs}
            />
            <Route
              path="/funding"
              component={Funding}
            />
            <Route
              path="/subscribe"
              component={Subscribe}
            />
            <Route
              exact
              path="/subscribe/:ctype/:item_id"
              component={Subscribe}
            />
            <Route
              exact
              path="/subscribe_confirm/:item_id"
              component={SubscribeConfirm}
            />
            <Route
              exact
              path="/terms"
              component={Terms}
            />
            <Route
              exact
              path="/privacy"
              component={Privacy}
            />

          </Layout>
        </Switch>
      </BrowserRouter>
    </>
  )
}

export default Root
ReactDOM.render(
  <React.StrictMode>
    <SimpleReactLightbox>
      <SessionProvider>
        <Root />
      </SessionProvider>
    </SimpleReactLightbox>
  </React.StrictMode>,
  document.getElementById("root")
);
